import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

export interface ViewPresentedEventParams {
  presentation_id: string;
  interaction_id?: string;
  flow_name?: string;
  view_type: string;
  view_name: string;
  view_details?: string;
  view_location: string;
  source: string;
}

function useViewPresentedEvent() {
  const viewPresented = useCallback(
    ({
      presentation_id,
      interaction_id,
      flow_name = '',
      view_type,
      view_name,
      view_details = '',
      view_location,
      source,
    }: ViewPresentedEventParams) => {
      const flow = flow_name ? AnalyticsService.getFlow(flow_name) : undefined;
      AnalyticsService.dispatchEvent(eventNames.CONTENT_STUDIO_VIEW_PRESENTED, {
        presentation_id,
        interaction_id,
        flow_id: flow?.flow_id || '',
        view_type,
        view_name,
        view_details,
        view_location,
        source,
      });
    },
    []
  );

  return {viewPresented};
}

export default useViewPresentedEvent;
